import { useContext } from 'react'
import { DeviationContext } from './deviation.context'

export function useDeviation() {
  return useContext(DeviationContext)
}
